
export const experienceMain = [
  {
    name: 'experience',
    path: '/experience',
    meta: {
      title: '体验账号',
      icon: 'shezhi'
    }
  },
  {
    name: 'experienceSet',
    path: '/experience/set',
    component: () => import('/@/views/plugins/experience/Set.vue'),
    meta: { title: '平台设置' }
  },
  {
    name: 'experienceCategory',
    path: '/experience/category',
    component: () => import('/@/views/plugins/experience/Category.vue'),
    meta: { title: '平台分类' }
  },
  {
    name: 'experienceList',
    path: '/experience/list',
    component: () => import('/@/views/plugins/experience/List.vue'),
    meta: { title: '账号管理' }
  }
]
